<div class="params">
    <ng-container *ngFor="let param of controls">
        <ng-container *ngIf="param.Tp === 9">
            <ng-container *ngTemplateOutlet="control; context: { isActive: param.LV.V === true, param: param }"></ng-container>
        </ng-container>
        <ng-container *ngIf="param.Tp === 16">
            <ng-container *ngTemplateOutlet="control; context: { isActive: param.LV.V !== true, param: param }"></ng-container>
        </ng-container>
        <ng-container *ngIf="param.Tp === 19">
            <ng-container *ngTemplateOutlet="control; context: { isActive: param.LV.V !== true, param: param }"></ng-container>
        </ng-container>
        <ng-container *ngIf="param.Tp === 26">
            <ng-container *ngTemplateOutlet="control; context: { isActive: param.LV.V !== true, param: param }"></ng-container>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="hiddenControlCount > 0">
        <ng-container *ngTemplateOutlet="control; context: { isActive: false, param: null, count: hiddenControlCount }"></ng-container>
    </ng-container>
</div>

<ng-template #control let-isActive="isActive" let-param="param" let-count="count">
    <div [ngClass]="{'active': isActive, 'is-count': count}" class="params__item" [title]="param?.Nm | translateByText">
        <span>
            {{ count ? ("+" + count) : param.Nm.slice(0,2) }}
        </span>
    </div>
</ng-template>
